import { useNavigate } from 'react-router-dom';
import StoreInfo from '../components/store-info/StoreInfo';
import ProductList from '../components/products/ProductList';
import { PurchaseFomo } from '../components/fomo';
import { OffersStrip, useOffers } from '../components/offers';
import { useCartStore } from '../store/useCartStore';

const HomePage = () => {
  const navigate = useNavigate();
  const cartCount = useCartStore((state) => state.count);
  const { offers, isLoading: offersLoading } = useOffers();

  // النقر على العرض: مع سلة غير فارغة ننتقل للدفع، وإلا ننزل لقائمة المنتجات
  const handleSelectOffer = () => {
    if (cartCount > 0) {
      navigate('/checkout');
      return;
    }
    document.getElementById('products')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  // عرض المحتوى مباشرة - كل مكون يدير حالة التحميل الخاصة به
  // StoreInfo و ProductList يعرضان الهيكل العظمي أثناء التحميل
  return (
    <>
      <StoreInfo />
      <OffersStrip
        title="عروض مميزة"
        offers={offers}
        isLoading={offersLoading}
        onSelect={handleSelectOffer}
      />
      <div id="products">
        <ProductList />
      </div>
      <PurchaseFomo />
    </>
  );
};

export default HomePage;
